import { TrendingUp } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"

/**
 * OKS-503 — Cold-start empty state for the EMV dashboard.
 *
 * Renders when `state === "cold_start"` — the brand has no tracked posts
 * at all (no approved submission has collected a snapshot yet). Unlike
 * the mission overview's cold-start, there is NO CTA here: EMV is a
 * downstream read of engagement the brand can't directly create from
 * this surface (UX Spec §3). The range toggle stays visible above this
 * card; only the data regions collapse to this single card.
 */
export function EmvEmptyState() {
  const { t } = useTranslation()

  return (
    <Card
      data-testid="emv-empty-state"
      className="mx-auto flex max-w-md flex-col items-center gap-4 p-8 text-center sm:p-12"
    >
      <CardContent className="flex flex-col items-center gap-4 p-0">
        <TrendingUp
          className="text-muted-foreground h-8 w-8"
          aria-hidden="true"
        />
        <h2 className="text-foreground text-xl font-semibold">
          {t("emv.empty.cold_start.title")}
        </h2>
        <p className="text-muted-foreground text-sm">
          {t("emv.empty.cold_start.body")}
        </p>
      </CardContent>
    </Card>
  )
}
